<div class="dialog-area" style="overflow: hidden;">
  <div mat-dialog-title class="modal-title">
    <h1>{{'Réplicas' | translate}}</h1>
    <a (click)="onNoClick()">X</a>
  </div>
  <div class="divider">
  </div>
  <div mat-dialog-content class="content">
    <div class="pb-3 row gap-3">
      <h4>Historico de réplicas</h4>
      @if (notaFiscal.replicas === null || notaFiscal.replicas?.length === 0) {
        <span>Sem histórico de replicas</span>
      }
      @for (replica of notaFiscal.replicas; track replica) {
        <div class="form-group">
          <div class="form-group" style="border: 1px solid black;">
            <p>
              {{'Data' | translate}}: {{replica?.dataCriacao | date: 'dd/MM/yyyy'}}
            </p>
            <p>{{'Observação' | translate}}: {{replica.descricao}}</p>
            <p>Status: {{replica.status | translate}}</p>
            @for (img of replica?.imagens; track img) {
              <div class="pb-3">
                <span>{{ img?.descricao }} - </span>
                <a (click)="openFile(img.imagem!, img.imagemContentType)" style="cursor: pointer;">
                  @if (img.imagemContentType?.includes('image')) {
                    <img [src]="'data:' + img.imagemContentType + ';base64,' + img.imagem" style="max-width: 200px" alt="notaFiscal image" />
                  }
                </a>
                @if (img.imagemContentType?.includes('pdf')) {
                  <a (click)="openFile(img.imagem!, img.imagemContentType)" style="cursor: pointer;">
                    {{'Clique para abrir o documento PDF' | translate}}
                  </a>
                }
                @if (img.imagemContentType?.includes('kml')) {
                  <a (click)="openFileKML(img.imagem!, img.imagemContentType)" style="cursor: pointer;">
                    {{'Clique para baixar o arquivo KML' | translate}}
                  </a>
                }
              </div>
            }
            <p >{{'Criado por' | translate}}:
              @if (replica.userCriadoPor.id !== 1) {
                <span>{{replica.userCriadoPor.firstName | titlecase}} {{replica.userCriadoPor.lastName | titlecase}}</span>
              }
              @if (replica.userCriadoPor.id === 1) {
                <span >Jiantan</span>
              }
            </p>
          </div>
        </div>
      }
    </div>
    <form name="editForm" role="form" novalidate (ngSubmit)="save()" [formGroup]="editForm">
      <div class="d-flex flex-column pb-3">
        <h4 class="title pb-3">{{'Enviar nova réplica' | translate}}</h4>
        <mat-form-field class="w-75">
          <mat-label>{{'Réplica' | translate}}</mat-label>
          <textarea matInput class="form-control" formControlName="descricao"></textarea>
        </mat-form-field>
        <button (click)="novaImagem()" type="button" name="button" class="btn btn-outline-success w-50">Nova imagem</button>
        @for (imagem of replica.imagens; track imagem; let i = $index) {
          <div class="d-flex pt-3 align-items-center">
            <mat-form-field class="w-75 pt-3" appearance="outline">
              <ngx-mat-file-input id="file_imagem" data-cy="imagem" (change)="setFileData($event, 'imagem', i)" accept="application/pdf, image/*, application/vnd.google-earth.kml+xml, application/inkml+xml/*">
              </ngx-mat-file-input>
              <mat-label>
                <div class="d-flex align-items-center label gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#6D6D6D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17 8L12 3L7 8" stroke="#6D6D6D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 3V15" stroke="#6D6D6D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <h6 class="m-0">{{'Faça o upload do seu comprovante aqui' | translate}}</h6>
                </div>
              </mat-label>
            </mat-form-field>
            <button mat-icon-button (click)="removeFile(i)">
              <mat-icon style="color: red;">close</mat-icon>
            </button>
          </div>
        }
        <!--
        <mat-form-field class="w-75 pt-3">
          <mat-select class="form-control" [ngModelOptions]="{ standalone: true }" name="status" [(ngModel)]="notaFiscal.status">
            <mat-option *ngFor="let status of statusValues" [value]="status">
              {{ status | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->


      </div>
      <div class="divider"></div>
      <div class="buttons pt-4">
        <button type="button" class="btn btn-outline-success" (click)="onNoClick()">{{'Cancelar' | translate}}</button>
        <button type="submit" class="btn btn-success" [disabled]="editForm.invalid || isSaving">{{'Salvar' | translate}}</button>
      </div>
    </form>
  </div>
</div>
